<template>
    <div v-if="show" class="drop-btn-block">
        <div v-show="show" :class="{ 'save-button-drop': true ,[position]:true}">
            <button class="save-button hover" @click="confirm">Сохранить</button>
            <button class="cancel-button hover" @click="cancel">Отменить</button>
        </div>
    </div>
  </template>
  
  
<script>
export default {
    name: 'save-modal',
    props:['show','position'],
    setup(_, { emit }) {
      
    const confirm = () =>{
        emit('save')
    }

    const cancel = ()=>{
        emit('cancel',false)
    }
        
    return {
      cancel,
      confirm
    };

    },
  };
  </script>
  
  
  <style scoped>
  
.drop-btn-block{
  position: relative;
}

.save-button-drop{
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 15px;
  position: fixed;
}

.bottom-left {
  bottom: 20px;
  left: 60px;
}

.bottom-right {
  bottom: 20px;
  right: 60px;
}


.save-button{
  width: 150px;
  height: 30px;
  border: 1px solid;
  border-radius: 5px;
  background-color: #007BFF;
  color: white;
}

.cancel-button{
  width: 150px;
  height: 30px;
  border: 1px solid;
  border-radius: 5px;
  background-color: #b83235;
  color: white;
}

.hover:hover{
  cursor: pointer;
  background-color: #444;
}
  
  </style>
  